import {Component, OnInit, ViewChild} from '@angular/core';
import {Invoice} from '../../../dto/invoice';
import {CardActivation} from '../../../dto/card-activation';
import {FileImportDialogComponent} from '../../../shared/file-import-dialog/file-import-dialog.component';
import {MatTableGeneratorComponent} from '../../../shared/mat-table-generator/mat-table-generator.component';
import {CardActivationImportService} from '../../services/card-activation-import.service';
import {DatePipe} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {RoleService} from '../../../services/role.service';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CardRenewalService} from '../../services/card-renewal.service';
import {FileHelper} from '../../../helpers/file-helper';
import {MultiCrudDataSource} from '../../../table-datasouces/multi-crud.datasource';
import {CardRenewalImport} from '../../../dto/card-renewal-import';
import {OrderImport} from '../../../dto/order-import';
import {DateFormats} from '../../../providers/app-date-adapter';

@Component({
  selector: 'app-card-renewal',
  templateUrl: './card-renewal.component.html',
  styleUrls: ['./card-renewal.component.css']
})
export class CardRenewalComponent implements OnInit {
  dataSource = new MultiCrudDataSource(this.cardRenewalService);
  columns = [
    { columnDef: 'id',              header: 'id',      cell: (row: CardRenewalImport) => `${row.id}`},
    { columnDef: 'date',            header: 'Date',    cell: (row: CardRenewalImport) => `${this.datePipe.transform(row.date, DateFormats.DisplayDateTime )}`},
    { columnDef: 'userName',        header: 'User',    cell: (row: CardRenewalImport) => `${row.username}`},
    { columnDef: 'ipAddress',       header: 'Ip address',   cell: (row: CardRenewalImport) => `${row.ipAddress}`},
    { columnDef: 'totalRowCount',   header: 'Total rows',   cell: (row: CardRenewalImport) => `${row.totalRowCount}`},
    { columnDef: 'invalidRowCount', header: 'Invalid rows', cell: (row: CardRenewalImport) => `${row.invalidRowCount}`},
    { columnDef: 'pendingCardsCount', header: 'Pending cards', cell: (row: CardRenewalImport) => `${(row.totalRowCount - row.invalidRowCount) - row.finishedCardsCount}`},
    { columnDef: 'finishedCardsCount', header: 'Finished cards', cell: (row: CardRenewalImport) => `${row.finishedCardsCount}`},
  ];
  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  getViewLink = (item: CardRenewalImport): string => item.id.toString();

  constructor(
    private cardRenewalService: CardRenewalService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
  ) {

  }

  ngOnInit() {
  }

  onUpload(file) {
    this.isLoading = true;
    this.cardRenewalService.uploadGenerationCsv(file)
    .subscribe(
      result => {

        this.dataSource.data.splice(0, 0, result); // insert on top
        this.table.refreshTable();
        this.isLoading = false;

        this.dialog.open(FileImportDialogComponent, {
          data: {
            import: result,
            link: this.router.url + '/' + result.id.toString()
          },
          maxWidth: 400,
        });


      },
      err =>
        this.snackBar.open( err.error.message || err.message || err.error || err, null, {
          duration: 5000,
          panelClass: [ 'app-mat-snack-bar' ]
        } )
    );
      /*.subscribe(response => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
        let filename = "renewals-for-cc-portal.csv"
          downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
      });*/
  }

  multiselectEnabled() {
    return false;
  }

  getRowClass = (item: any): string => item.importErrorsText ? 'warning-row' : '';
  isLoading: boolean;

  deleteEnabled() {
    return false;
  }
}
